import { Reducer } from "react"
import { handleActions } from "redux-actions"
import { 
    ACTION_GETREPORTLISTENTRYINS_SUCCESS,
    ACTION_GETREPORTLISTENTRYINSBYSTATUS_SUCCESS,
    ACTION_GETREPORTLISTENTRYMERCHANT_SUCCESS,
    ACTION_GETREPORTLISTENTRYMERCHANTBYSTATUS_SUCCESS,
    ACTION_GETREPORTDETAIL_SUCCESS,
    ACTION_GETREPORTDETAILBYSTATUS_SUCCESS,
    ACTION_SAVEREPORTREMARK_SUCCESS,
    ACTION_EXPORTDATA_SUCCESS,
    ACTION_EXPORTFEETSTL_SUCCESS,
 } from "../../actions/silizhu/report"

export interface silizhuReportState {
    reportList: any
    reportDetail: any
}

const defaultState: silizhuReportState = {
    reportList: {},
    reportDetail: {},
}


function handleActionGetReportListSuccess(state: silizhuReportState, action): silizhuReportState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        reportList: action.payload.data
    }
}


function handleActionGetReportDetailSuccess(state: silizhuReportState, action): silizhuReportState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        reportDetail: action.payload.data,
    }
}

function handleActionNoDataSuccess(state: silizhuReportState, action): silizhuReportState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
    }
}


export const silizhuReportReducer: Reducer<silizhuReportState, any> = handleActions(
    {
        [ACTION_GETREPORTLISTENTRYINS_SUCCESS]: handleActionGetReportListSuccess,
        [ACTION_GETREPORTLISTENTRYMERCHANT_SUCCESS]: handleActionGetReportListSuccess,
        [ACTION_GETREPORTLISTENTRYINSBYSTATUS_SUCCESS]: handleActionGetReportListSuccess,
        [ACTION_GETREPORTLISTENTRYMERCHANTBYSTATUS_SUCCESS]: handleActionGetReportListSuccess,
        [ACTION_GETREPORTDETAIL_SUCCESS]: handleActionGetReportDetailSuccess,
        [ACTION_GETREPORTDETAILBYSTATUS_SUCCESS]: handleActionGetReportDetailSuccess,
        [ACTION_SAVEREPORTREMARK_SUCCESS]: handleActionNoDataSuccess,
        [ACTION_EXPORTDATA_SUCCESS]: handleActionNoDataSuccess,
        [ACTION_EXPORTFEETSTL_SUCCESS]: handleActionNoDataSuccess,
    },
    defaultState
)